import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Can from "../../common/Can";
import { Navigate } from "react-router";
import { usePermissionContext, useRoleContext } from "../../../contexts/ProviderProvider";
import ComplianceFinancialDashboardV2 from './ComplianceFinancialDashboardV2';

export const Component = () => {
  const { views } = usePermissionContext();
  const { role } = useRoleContext();

  return (
    <Can action={views.VIEW} items={[views.FINANCE]} els={<Navigate to="/ballpark/" />}>
      <ComplianceFinancialDashboardV2 view={role != 'Compliance Admin' ? "Internal" : "External"} />
    </Can>
  );
}
export const icon = <AttachMoneyIcon />;
export const text = "Financial Dash V2";
export const componentName = "Financial Dash V2";
export const path = "financialDashV2";
